import { render, staticRenderFns } from "./FileContent.vue?vue&type=template&id=797dfc97&scoped=true"
import script from "./FileContent.vue?vue&type=script&lang=js"
export * from "./FileContent.vue?vue&type=script&lang=js"
import style0 from "./FileContent.vue?vue&type=style&index=0&id=797dfc97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797dfc97",
  null
  
)

export default component.exports